module.exports = __webpack_public_path__ + "media/img/apple-icon-120x120-db6093e3afead50793dd0cf63462704d.png";